export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9058.c1c50af7.jpg";